import { render } from "./BaseSidebarObjectEditor.vue?vue&type=template&id=4b388da6"
import script from "./BaseSidebarObjectEditor.vue?vue&type=script&lang=js"
export * from "./BaseSidebarObjectEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__